var map = {
	"./ConsultingCoverOne.jpg": 53,
	"./ConsultingCoverTwo.jpg": 4855,
	"./ConsultingHead.jpg": 1533,
	"./MobileDetection.jpg": 7538,
	"./MobileDetection2.jpg": 9560,
	"./SectionOneImage.jpg": 3291,
	"./SectionTwoImage.jpg": 2792,
	"./SolutionsBanner.jpg": 9007,
	"./black-bg.jpg": 9293,
	"./branches-banner.jpg": 5250,
	"./more-info.jpg": 9504,
	"./s1.jpg": 158
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4738;